module.exports = __webpack_public_path__ + "static/media/PayPal.3e9607d3.svg";